import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'
import parser from 'html-react-parser'

export default function Donation2({ data }) {
    const { donation2ButtonText, donation2Text, donation2ButtonLink, donation2Title, donation2Image, donation2ButtonExternalLink } = data
    return (
        <div className='image-radius-pattern-2 donate-support-sec p-0'>
            <div className='donate-inr-support-sec'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-5'>
                            <div className='image-r-patrn-2 img-yellow-bg'>
                                <GatsbyImage
                                    image={getImage(donation2Image?.localFile)}
                                    alt='image'
                                />
                            </div>
                        </div>
                        <div className='col-md-7'>
                            <div className='heading-level-2-i white-color text-uppercase'>
                                {donation2Title && parser(donation2Title)}
                            </div>
                            <div className='heading-level-3-i mb-3 blue-color text-uppercase upper-heading'>
                                {donation2Text && parser(donation2Text)}
                            </div>
                            {donation2ButtonExternalLink ? (
                                <a href={donation2ButtonExternalLink} className="btn white-btn">
                                    {donation2ButtonText}
                                </a>
                            ) : donation2ButtonLink ? (
                                <Link to={donation2ButtonLink.uri} className='btn white-btn'>
                                    {donation2ButtonText}
                                </Link>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
